import React from 'react';
import { useAppSelector } from '../../app/hooks';
import {
    selectBiometricsExists,
    selectBiometricsType,
    selectRefreshToken,
} from '../../appSlice';
import SettingsButton, {
    SettingsConfig,
} from '../../components/SettingsButton';
import Toggle from '../../components/Toggle';
import {
    deleteBiometrics,
    openAppSettings,
    openBiometricsSettings,
    setupBiometrics,
} from '../../utils/webview/messages';

const SecurityPage: React.FC = () => {
    const refreshToken = useAppSelector(selectRefreshToken);
    const biometricsType = useAppSelector(selectBiometricsType);
    const biometricsExists = useAppSelector(selectBiometricsExists);

    const goToAppSettings = () => {
        openAppSettings();
    };

    const goToBiometricsSettings = () => {
        openBiometricsSettings();
    };

    const privacyOptions: SettingsConfig[] = [
        {
            value: 'Location',
            text: 'Manage',
            callback: () => goToAppSettings(),
        },
        {
            value: 'Notifications',
            text: 'Manage',
            callback: () => goToAppSettings(),
        },
        {
            value: 'Camera',
            text: 'Manage',
            callback: () => goToAppSettings(),
        },
    ];

    if (biometricsType && refreshToken) {
        const biometricsLabel = biometricsType.includes('FaceID')
            ? 'Face ID'
            : biometricsType.includes('Fingerprint')
              ? 'Fingerprint'
              : 'Biometrics';

        if (biometricsType.includes('_NOT_READY')) {
            privacyOptions.push({
                value: biometricsLabel,
                text: 'Manage',
                callback: () => goToBiometricsSettings(),
            });
        } else {
            privacyOptions.push({
                value: biometricsLabel,
                text: (
                    <Toggle
                        value={!!biometricsExists}
                        onChange={(value) =>
                            value ? setupBiometrics() : deleteBiometrics()
                        }
                        id="security_page"
                    />
                ),
                transparent: true,
            });
        }
    }

    return <SettingsButton options={privacyOptions} />;
};

export default SecurityPage;
